import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ActivateAccountComponent } from './activate-account/activate-account.component';
import { ChangePasswordComponent } from './change-password/change-password.component';

export const AuthRoutes: Routes = [
    {
        path: '',
        component: LoginComponent
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent
    },
    {
        path: 'activate-account',
        component: ActivateAccountComponent
    },
    {
        path: 'change-password',
        component: ChangePasswordComponent
    },
]
